import { Injectable } from '@angular/core';
import { HssResponse } from './HssResponse';
import { HssErrorResponse } from './HssErrorResponse';
import { InfoApiService } from './info.api.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(private _info: InfoApiService) { }

  setdata(key:string, data: any){
    const jsonData = JSON.stringify(data)
    localStorage.setItem(key, jsonData)
  }

  getData(data: string) {
    return localStorage.getItem(data)
  }

  removeData(key: any) {
    localStorage.removeItem(key)
  }

  // Get staff member list and store in local storage
  getStaffMemberList(){
    // this.staffLoader = true;
    this._info.getStaffMemberList().subscribe (
      (response: HssResponse<any>) => {

        this.setdata('staffData',response.body);
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;

      }
    );
  }

  // Get faculty bu id and store in local storage
  getFacultyById(id: number){
    this._info.getFacultyById(id).subscribe (
      (response: HssResponse<any>) => {
        this.setdata('facultyData',response.body);
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;

      }
    );
  }
}
